<div
  #viewport
  class="bds-scroll-region__viewport"
  [ngClass]="styleClass"
  [attr.aria-label]="ariaLabel"
  role="region"
>
  <div #content class="bds-scroll-region__content">
    <ng-content></ng-content>
  </div>
</div>

@if (overflow()) {
  <div
    class="bds-scroll-region__track"
    aria-hidden="true"
    [class.bds-scroll-region__track--dragging]="dragging()"
    [class.bds-scroll-region__track--active]="scrolling() || dragging()"
  >
    <div
      class="bds-scroll-region__thumb"
      [style.height.px]="thumbHeightPx()"
      [style.transform]="'translateY(' + thumbTopPx() + 'px)'"
      (pointerdown)="onThumbPointerDown($event)"
      (pointermove)="onThumbPointerMove($event)"
      (pointerup)="onThumbPointerUp($event)"
      (pointercancel)="onThumbPointerUp($event)"
    ></div>
  </div>
}
